/* Kontaktformular — Bestätigung gegen Spam. 03.09.2026.

   WAS DAS HIER LEISTET UND WAS NICHT — bitte zuerst lesen.

   Shopifys Kontaktformular schickt seine Daten per POST an /contact.
   Geprueft wird dort auf Shopifys Servern, und dorthin kommt kein
   Skript von uns. Alles, was diese Datei tut, laeuft im BROWSER des
   Absenders. Ein Programm, das stumpf an /contact postet, ohne die Seite
   je zu laden, merkt davon nichts.

   Damit ist klar, wogegen es hilft und wogegen nicht:

     hilft   gegen Programme, die eine echte Seite laden und Formulare
             ausfuellen — der heute haeufigste Fall bei Formularspam
     hilft   gegen Koeder-Faelle: wer ein unsichtbares Feld ausfuellt,
             ist kein Mensch
     hilft   gegen Absenden in Millisekunden
     NICHT   gegen einen direkten POST an /contact

   Das Einzige, was auch dagegen hilft, ist Shopifys eigener Spamschutz
   (Google reCAPTCHA). Der wird SERVERSEITIG geprueft, bevor die Nachricht
   ueberhaupt zugestellt wird, und laesst sich nur im Admin einschalten —
   nicht ueber die API, nicht ueber das Theme:

       Onlineshop -> Einstellungen -> Spam-Schutz
       "Google reCAPTCHA fuer Kontaktformulare ... aktivieren"

   Sobald der Schalter steht, haengt Shopify sein reCAPTCHA von selbst in
   {% form 'contact' %}. Am Theme ist dafuer nichts zu tun, und diese
   Datei stoert es nicht — sie prueft nur zusaetzlich.

   --- Warum kein Eingriff in die Theme-Datei ---

   Das Formular steht in sections/contact-template.liquid. Die Felder dort
   einzufuegen waere der NEUNTE Eingriff auf Ebene C, und jeder weitere
   ist abzusprechen. Zur Laufzeit eingehaengt kostet es keinen: Die
   Theme-Datei bleibt unberuehrt und uebersteht jedes Update.

   --- Ohne JavaScript ---

   Dann erscheint das Kontrollkaestchen nicht, und das Formular
   funktioniert wie vorher — ohne Pruefung. Auch deshalb ist der Schalter
   im Admin die eigentliche Loesung und das hier die zweite Reihe.
*/
(function () {
  'use strict';

  var formular = document.querySelector('form[action*="/contact"]');
  if (!formular) return;

  /* Ein zweiter Lauf soll nichts verdoppeln. */
  if (formular.getAttribute('data-penovia-geprueft')) return;
  formular.setAttribute('data-penovia-geprueft', '1');

  var geladen = Date.now();
  var MINDESTZEIT = 3000;

  /* --- Koederfeld -------------------------------------------------
     Unsichtbar, aber NICHT display:none — Programme ueberspringen
     ausgeblendete Felder oft absichtlich. Weggeschoben werden sie
     ausgefuellt. Der Name traegt bewusst kein contact[...]: Alles in
     diesem Namensraum landet sonst im Text der E-Mail. */
  var koeder = document.createElement('div');
  koeder.className = 'penovia-koeder';
  koeder.setAttribute('aria-hidden', 'true');
  koeder.innerHTML =
    '<label>Webseite<input type="text" name="penovia_koeder" tabindex="-1" autocomplete="off"></label>';

  /* --- Bestaetigung -----------------------------------------------
     required erledigt die Pflicht: Der Browser blockt das Absenden
     selbst und meldet es in der Sprache des Besuchers. Unser eigener
     Hinweis kommt dazu, weil die Browsermeldung an einem Kaestchen
     leicht uebersehen wird. */
  var block = document.createElement('p');
  block.className = 'penovia-pruefung';
  block.innerHTML =
    '<label class="penovia-pruefung__wahl">' +
      '<input type="checkbox" id="penovia-kein-roboter" class="penovia-pruefung__kasten" required>' +
      '<span class="penovia-pruefung__text">Ich bin kein Roboter</span>' +
    '</label>' +
    '<span class="penovia-pruefung__hinweis" id="penovia-pruefung-hinweis" role="alert" hidden></span>';

  var absenden = formular.querySelector('.contact-submit') || formular.querySelector('[type="submit"]');
  var ziel = absenden && absenden.parentNode === formular.querySelector('.contact-form')
    ? absenden
    : (absenden ? absenden.closest('p') || absenden : null);

  if (ziel && ziel.parentNode) {
    ziel.parentNode.insertBefore(koeder, ziel);
    ziel.parentNode.insertBefore(block, ziel);
  } else {
    formular.appendChild(koeder);
    formular.appendChild(block);
  }

  var kasten = block.querySelector('.penovia-pruefung__kasten');
  var hinweis = block.querySelector('.penovia-pruefung__hinweis');
  var koederfeld = koeder.querySelector('input');

  function meldung(text) {
    if (!text) {
      hinweis.hidden = true;
      hinweis.textContent = '';
      return;
    }
    hinweis.textContent = text;
    hinweis.hidden = false;
  }

  kasten.addEventListener('change', function () {
    if (kasten.checked) meldung('');
  });

  formular.addEventListener('submit', function (e) {
    /* Koeder gefuellt: abbrechen, ohne zu erklaeren warum. Wer es
       ausgefuellt hat, ist kein Mensch — und ein Hinweis waere nur eine
       Anleitung zum Umgehen. */
    if (koederfeld && koederfeld.value !== '') {
      e.preventDefault();
      return;
    }

    if (!kasten.checked) {
      e.preventDefault();
      meldung('Bitte bestätigen Sie, dass Sie kein Roboter sind.');
      kasten.focus();
      return;
    }

    if (Date.now() - geladen < MINDESTZEIT) {
      e.preventDefault();
      meldung('Einen Moment noch — bitte senden Sie das Formular gleich nochmal ab.');
      return;
    }

    meldung('');
  });
})();
